import React from "react";
import { Link } from "react-router-dom";
import { ButtonCollection, ButtonHauptmenü, MainMenue } from "../Login/AppStyle";
import { userAdmin, userVci } from "../../constants/const";

export default function Categories() {
    return (
        <MainMenue>
            <section>
                <h3>Allgemeine Bereiche</h3>
                <ButtonCollection>
                    {sessionStorage.getItem('token').includes(userVci) &&
                        <Link to="/stammdaten">
                            <ButtonHauptmenü>Stammdaten</ButtonHauptmenü>
                        </Link>}
                    {sessionStorage.getItem('token').includes(userVci) &&<Link to="/jahreszahlen">
                        <ButtonHauptmenü>jährliche Kennzahlen</ButtonHauptmenü>
                    </Link>}
                    <Link to="/datenerfassung">
                        <ButtonHauptmenü>Datenerfassung</ButtonHauptmenü>
                    </Link>
                    <Link to="/reporting">
                        <ButtonHauptmenü>Reporting</ButtonHauptmenü>
                    </Link>
                    <Link to="/support">
                        <ButtonHauptmenü>Support</ButtonHauptmenü>
                    </Link>
                </ButtonCollection>
            </section>

            {sessionStorage.getItem('token').includes(userVci) && <section>
                <h3>vci Bereich</h3>
                <ButtonCollection>
                    <Link to="/aufgaben">
                        <ButtonHauptmenü>Aufgaben</ButtonHauptmenü>
                    </Link>
                    <Link to="/notizen">
                        <ButtonHauptmenü>Notizen</ButtonHauptmenü>
                    </Link>
                </ButtonCollection>
            </section>}

            <section>
                <h3>Benutzerkonto</h3>
                <ButtonCollection>
                    <Link to="/benutzerkonto">
                        <ButtonHauptmenü>Passwort ändern</ButtonHauptmenü>
                    </Link>
                    {sessionStorage.getItem('token').includes(userAdmin) &&
                        <Link to="/kontenverwaltung">
                            <ButtonHauptmenü>Kontenverwaltung</ButtonHauptmenü>
                        </Link>}
                </ButtonCollection>
            </section>

            {sessionStorage.getItem('token').includes(userAdmin) && <section><h3>Testbereich</h3>
                <ButtonCollection>
                    <Link to="/bilder">
                        <ButtonHauptmenü>Testbild</ButtonHauptmenü>
                    </Link>
                    <Link to="/map">
                        <ButtonHauptmenü>Streetmap</ButtonHauptmenü>
                    </Link>
                </ButtonCollection>
            </section>}
        </MainMenue>
    );
}
